import { useHoneyGridApiFetch } from '@/queries/useHoneyGridApiFetch'
import { useQuery } from '@tanstack/react-query'

import type { Grid } from 'honeygrid-types'

export const gridsQueryKey = (workspaceId?: string, include?: string) =>
	['grids', workspaceId, ...(include ? [include] : [])] as const

interface GridsParams {
	workspaceId?: string
	include?: string
}

export const useGrids = ({ workspaceId, include }: GridsParams) => {
	const authFetch = useHoneyGridApiFetch()

	return useQuery<Grid[]>({
		queryKey: gridsQueryKey(workspaceId, include),
		queryFn: (): Promise<Grid[]> =>
			authFetch(
				`workspaces/${workspaceId}/grids${include ? `?include=${encodeURIComponent(include)}` : ''}`
			),
		enabled: !!workspaceId,
	})
}
